import { useCallback } from 'react';
import { segment } from '../services/segment';

export const EVENTS = {
  PageViewed: 'pageViewed',
  ButtonClicked: 'buttonClicked',
  ModalOpened: 'modalOpened',
  Error: 'error',
} as const;

type EventName = (typeof EVENTS)[keyof typeof EVENTS];
type EventProperties = Record<string, string | number | boolean | null | undefined>;

export function useSegmentTracking() {
  const track = useCallback((event: EventName, properties: EventProperties = {}) => {
    try {
      segment.track(event, properties);
    } catch {
      // analytics errors should not impede application flow
    }
  }, []);

  const identify = useCallback((userId: string) => {
    try {
      segment.identify(userId);
    } catch {
      // analytics errors should not impede application flow
    }
  }, []);

  return { track, identify };
}
